module.exports = __webpack_public_path__ + "static/img/icon_contact_service.d3d76aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_contact_service.png
// module id = tMIL
// module chunks = 1